<template>
  <div
    v-if="flow.actionArea.visible"
    class="actionArea"
  >
    <button
      v-if="flow.actionArea.skip"
      id="bnpl_psd2_skip"
      class="linkButton linkButtonSuccess justify-self-start-desktop leftAction"
      @click="flow.skip"
    >
      <i class="pi pi-arrow-right" />{{ $t("bnpl:skip") }}
    </button>
    <button
      v-if="flow.actionArea.previous"
      id="bnpl_psd2_previous_button"
      class="linkButton linkButtonSuccess justify-self-start-desktop leftAction"
      @click="flow.back"
    >
      <i class="pi pi-arrow-left" />{{ $t("bnpl:previousStep") }}
    </button>
    <button
      v-if="flow.actionArea.next.visible"
      id="bnpl_psd2_next_button"
      class="btn btnL rightAction"
      :disabled="flow.actionArea.next.disabled"
      @click="flow.next"
    >
      {{ $t(flow.actionArea.next.label ?? DEFAULT_NEXT_LABEL) }}
    </button>
  </div>
</template>

<script setup>
/**
 * The footer, for the hosts that let these screens draw their own.
 *
 * Both hosts had their own copy of this markup, and the copies had already
 * disagreed about what to do with a state that names no label of its own.
 */
const DEFAULT_NEXT_LABEL = "bnpl:next";

defineProps({
  flow: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.linkButton {
  font-size: 12px;
  color: var(--brandPrimary);
}
</style>
